import { REACT_APP_COOKIES_DOMAIN, STORAGE_PRFX } from "./config";
import moment from "moment";
import "moment-timezone";
import ct from "countries-and-timezones";
import { cw } from "@/lib/utils/index";

export const TabBgColor = "#d4884229";
export function formartGroupList(groupList = [], intl) {
  let systemGroups = groupList.filter((item) => item.type === "system");
  return groupList.map((group) => {
    if (group.parent_id) {
      let sysGroup = systemGroups.find(
        (sys) => sys.group_id === group.parent_id,
      );
      let ParentName = sysGroup
        ? `(${intl.formatMessage(cw[sysGroup.name])}) `
        : "";
      return {
        ...group,
        name: ParentName + group.name,
      };
    }
    return group;
  });
}
// ::: cookie
export const setCookie = (cname, cvalue, exdays = 7) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  const safeValue = cvalue === undefined || cvalue === null ? "" : cvalue;
  document.cookie = `${
    STORAGE_PRFX + cname
  }=${safeValue};${expires};path=/;domain=${REACT_APP_COOKIES_DOMAIN}`;
};

export const safeParseJSON = (value, fallback = null) => {
  if (
    value === undefined ||
    value === null ||
    value === "" ||
    value === "undefined" ||
    value === "null"
  ) {
    return fallback;
  }
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const getCookie = (cname) => {
  var name = STORAGE_PRFX + cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      if (c.split("=")[1].length !== 0) {
        return c.substring(name.length, c.length);
      }
    }
  }
  return "";
};
export const deleteCookie = (cname) => {
  var expires = "expires=-1";
  document.cookie = `${
    STORAGE_PRFX + cname
  }=;${expires};path=/;domain=${REACT_APP_COOKIES_DOMAIN}`;
};

// ::: storage
export const setStorage = (name, value) => {
  return localStorage.setItem(STORAGE_PRFX + name, value);
};
export const getStorage = (name, value) => {
  return localStorage.getItem(STORAGE_PRFX + name, value);
};
export const delStorage = (name) => {
  return localStorage.removeItem(STORAGE_PRFX + name);
};

export const titleCase = (str) => {
  return str
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

export const numberFormatter = (x, f = 2) => {
  return Number(x)
    .toFixed(f)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const truncate = (str, n) => {
  return str.slice(0, n);
};

export const getTimeZone = (ccc) => {
  // let as = '';
  const countries = ct.getAllCountries();
  let d = Object.values(countries);
  let aa = d.find((e) => e.name === ccc);

  if (aa) {
    return aa.timezones[0];
  } else {
    return moment.tz.guess();
  }
};

export const generateOptions = (
  length,
  disabledOptions,
  hideDisabledOptions,
  step = 1,
) => {
  const arr = [];
  for (let value = 0; value < length; value += step) {
    if (
      !disabledOptions ||
      disabledOptions.indexOf(value) < 0 ||
      !hideDisabledOptions
    ) {
      arr.push(value);
    }
  }
  return arr;
};

export const mergeObj = (obj, src) => {
  for (var key in src) {
    if (src.hasOwnProperty(key)) obj[key] = src[key];
  }
  return obj;
};

// check permission
export const hasP = (permission, myRole) => {
  var check = (process.env[`REACT_APP_${permission}`] || "")
    .split(",")
    .findIndex((role) => role === myRole);
  if (check === -1) {
    return false;
  }
  return true;
};

//check permission based on account or project id
export const hasPAccess = ({ permission, accountId, projectId }) => {
  const accessValues = (process.env[`REACT_APP_${permission}`] || "")
    .split(",")
    .map((v) => v.trim());

  return (
    (accountId && accessValues.includes(accountId)) ||
    (projectId && accessValues.includes(projectId))
  );
};

// checks access permission based on projectId and country name
export const checkAccess = ({ access = "", projectId, country }) => {
  const accessValues = access.trim().split(",");
  return (
    (projectId && accessValues.includes(projectId)) ||
    (country && accessValues.includes(country))
  );
};

export function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
